import { EntityType } from '@migrate/models/EntityType'
import { EntityTypeAvatar } from '@portal/pkg-filter-criteria'
import { styled } from '@mui/material'

const StyledRoot = styled('div')({
  display: 'flex',
  alignItems: 'center',
})

const StyledText = styled('div')({
  marginLeft: '10px',
  color: '#404040',
  fontWeight: 'bold',
  fontSize: 12,
})

const StyledSub = styled('div')({
  fontSize: 10,
  color: 'rgba(64, 64, 64, 0.5)',
})

interface IEntityItemProps {
  entityType: EntityType
  name: string
  id: number
}

const EntityItem = (props: IEntityItemProps) => {
  const { entityType, id, name } = props

  return (
    <StyledRoot>
      <EntityTypeAvatar entityType={entityType} size={24} />
      <StyledText>
        <div>{name}</div>
        <StyledSub>{id}</StyledSub>
      </StyledText>
    </StyledRoot>
  )
}

export default EntityItem
